import type { Resolvers, SyncSession } from '../../../../generated';
import { allSyncSessions, syncSessionsMap } from '../sync-session';

export const resolvers: Resolvers = {
  Mutation: {
    addSyncSession: (_, vars) => {
      const sessionId = crypto.randomUUID();
      const newSyncSession: SyncSession = {
        __typename: `SyncSession`,
        id: sessionId,
        ...vars.syncSession,
      };
      allSyncSessions.set((draft) => {
        draft.push(newSyncSession);
      });
      syncSessionsMap.set(sessionId, newSyncSession);
      return newSyncSession;
    },
  },
};
